export default __webpack_public_path__ + "static/media/abrirCaja.87ceb684.png";